'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { ArrowRight } from 'lucide-react';
import { useTranslation } from '@/lib/locales';
interface DirectionCardProps {
  image?: string;
  fallbackGradient: string;
  title: React.ReactNode;
  subtitle: string;
  href: string;
  linkLabel: string;
}
function DirectionCard(t0) {
  const $ = _c(22);
  const {
    image,
    fallbackGradient,
    title,
    subtitle,
    href,
    linkLabel
  } = t0;
  const t1 = `relative aspect-[4/3] overflow-hidden ${fallbackGradient}`;
  let t2;
  if ($[0] !== image) {
    t2 = image && <img src={image} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" onError={_temp} />;
    $[0] = image;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== title) {
    t4 = <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">{title}</h3>;
    $[5] = title;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== subtitle) {
    t5 = <p className="text-gray-500 text-sm leading-relaxed mb-4">{subtitle}</p>;
    $[7] = subtitle;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== linkLabel) {
    t7 = <span className="mt-auto inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 group-hover:underline">{linkLabel}{t6}</span>;
    $[10] = linkLabel;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t4 || $[13] !== t5 || $[14] !== t7) {
    t8 = <div className="p-6 flex flex-col items-center text-center flex-1">{t4}{t5}{t7}</div>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t3 || $[17] !== t8) {
    t9 = <div className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 flex flex-col h-full cursor-pointer">{t3}{t8}</div>;
    $[16] = t3;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== href || $[20] !== t9) {
    t10 = <Link href={href}>{t9}</Link>;
    $[19] = href;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}
function _temp(e) {
  (e.target as HTMLImageElement).style.display = "none";
}
export function DirectToRightPlaceV4() {
  const $ = _c(4);
  useTranslation();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-white text-center mb-10">How do you want to Sizzle?</h2>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <DirectionCard fallbackGradient="bg-gradient-to-br from-purple-200 to-purple-400" image="https://plus.unsplash.com/premium_photo-1682144509812-4734c830b486?w=600&h=450&fit=crop" href="/early-preview" title={<span>I want people to{" "}<span className="underline decoration-primary-500 decoration-3 underline-offset-2">discover and try</span>{" "}our products</span>} subtitle={"I\u2019m a brand, importer, distributor, or agency looking to get my products discovered and into people\u2019s hands"} linkLabel="Get Started" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <DirectionCard fallbackGradient="bg-gradient-to-br from-orange-200 to-orange-400" image="https://images.unsplash.com/photo-1604719312566-8912e9227c6a?w=600&h=450&fit=crop" href="/host-opportunities" title={<span>I want to{" "}<span className="underline decoration-primary-500 decoration-3 underline-offset-2">attract more people</span>{" "}to our place</span>} subtitle={"I\u2019m a retailer, cafe, bar, or venue looking to drive more foot traffic and bring new customers through the door"} linkLabel="Explore Place Opportunities" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <section className="py-16 lg:py-24 bg-gradient-to-b from-gray-900 to-slate-900"><div className="container mx-auto px-4 sm:px-6 lg:px-8">{t0}<div className="grid grid-cols-1 sm:grid-cols-3 gap-8 max-w-5xl mx-auto">{t1}{t2}<DirectionCard fallbackGradient="bg-gradient-to-br from-blue-200 to-blue-400" image="https://plus.unsplash.com/premium_photo-1761846736887-49c35b17b1b6?w=600&h=450&fit=crop" href="/host-opportunities" title={<span>I want brands to bring{" "}<span className="underline decoration-primary-500 decoration-3 underline-offset-2">activations or products</span>{" "}to us</span>} subtitle={"I\u2019m an event organiser or workplace manager looking for brands to bring activations, tastings, or product to my people or event"} linkLabel="Find Brand Partnerships" /></div></div></section>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}